export default __webpack_public_path__ + "static/media/kerjoo-tracker-logo.20fced0d.png";